.ux-iws-nb-teaser-contact {
    box-sizing: border-box;
    display: block;
    width: 100%;
    overflow-x: hidden;

    &__container {
        padding: 30px 0;
        background: #eff0f4;
        background: linear-gradient(90deg, #eff0f4 0%, #80a0b4 100%);
        position: relative;

        @media (min-width: 568px) and (max-width: 767px) {
            padding: 30px 15px;
        }

        @media (min-width: 768px) {
            padding: 30px 15px;
        }

        @media (min-width: 1024px) {
            padding: 30px 0;
        }
    }

    &__image {
        position: absolute;
        display: none;
        overflow: hidden;

        @media (min-width: 1024px) {
            display: block;
            inset: 60px 50% 60px 15px;
        }

        @media (min-width: 1440px) {
            inset: 0 50% 0 15px;
        }
    }

    &__image img {
        display: block;
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    &__box {
        position: relative;
        margin: 0;
        width: auto;
        background: #fff;
        padding: 40px;
        box-shadow: 0 0 25px rgba(0, 0, 0, 0.25);
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: flex-start;
        gap: 30px;

        @media (min-width: 568px) {
            padding: 60px;
        }

        @media (min-width: 1024px) {
            margin: 0 0 0 33.3333%;
        }

        @media (min-width: 1440px) {
            margin: 30px 0 30px 40%;
        }
    }

    &__headline {
        @include font(light);
        font-size: 20px;
        line-height: 1.2;
        margin: 0 0 10px;
        color: $color-black-1;

        span {
            display: block;
        }

        span:nth-child(2) {
            color: $color-black-2;
        }

        @media (min-width: 1024px) {
            font-size: 28px;
        }

        @media (min-width: 1440px) {
            font-size: 34px;
        }
    }

    &__header p {
        line-height: 1.2;
        color: $color-black-2;
        margin: 0;
    }

    &__contacts {
        width: 100%;
    }

    &__contacts h3,
    &__contacts h4,
    &__contacts h5 {
        @include font(light);
        font-size: $size-text-title;
        line-height: 1.2;
        margin: 0;
        color: $color-black-1;

        @media (min-width: 1024px) {
            font-size: 20px;
        }

        @media (min-width: 1440px) {
            font-size: 23px;
        }
    }

    &__contacts__content {
        margin-top: 12px;
        padding-top: 12px;
        width: 100%;
        border-top: 1px solid $color-black-5;
        display: flex;
        flex-flow: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 10px 30px;

        @media (min-width: 568px) {
            flex-flow: row wrap;
        }
    }

    &__contacts__content a {
        white-space: nowrap;
        display: inline-flex;
        gap: 5px;
        align-items: center;
        line-height: 20px;
    }

    &__contacts__content a:hover {
        color: $color-black;
    }

    &__links {
        display: flex;
        flex-flow: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 10px 30px;

        @media (min-width: 1024px) {
            flex-flow: row wrap;
            align-items: center;
        }
    }

    &__link {
        @include font(bold);
        font-size: $size-text-small;
        text-decoration: none;
        text-transform: uppercase;
        color: $color-blue-headline;
    }

    &__phone {
        @include font(light);
        font-size: $size-text-medium-plus;
        text-decoration: underline;
        text-transform: none;
        color: $color-black;
    }
}

.ux-iws-nb-teaser-contact--no-image {
    .ux-iws-nb-teaser-contact__image {
        display: none;

        @media (min-width: 1024px) {
            display: none;
        }

        @media (min-width: 1440px) {
            display: none;
        }
    }

    .ux-iws-nb-teaser-contact__box {
        @media (min-width: 1024px) {
            margin-left: 0;
        }

        @media (min-width: 1440px) {
            margin-left: 0;
        }

        @media (min-width: 1800px) {
            margin-left: 0;
        }
    }
}
